import { Controller } from "stimulus";
import debounce from "lodash.debounce";

export default class extends Controller {
  static targets = ["form", "iframe"];
  static values = {
    previewUrl: String
  };

  connect() {
    this.updatePreview = debounce(this.updatePreview.bind(this), 500);
    this.setupFormListeners();
    // Load preview on initial connect
    this.loadPreview();
  }

  setupFormListeners() {
    // Listen to all form inputs
    this.formTarget.querySelectorAll('input, textarea, select').forEach((input) => {
      input.addEventListener('input', () => this.updatePreview());
      input.addEventListener('change', () => this.updatePreview());
    });

    // Setup listeners for EasyMDE markdown editors after a short delay
    // to ensure they're fully initialized
    setTimeout(() => {
      this.setupMarkdownEditorListeners();
    }, 500);
  }

  setupMarkdownEditorListeners() {
    // Find all elements with data-controller="textarea" within the form
    const textareaContainers = this.element.querySelectorAll('[data-controller="textarea"]');

    textareaContainers.forEach((container) => {
      // Try to get the Stimulus controller instance
      const textareaController = this.application.getControllerForElementAndIdentifier(container, "textarea");

      if (textareaController && textareaController.editor) {
        // Hook into the CodeMirror change event
        textareaController.editor.codemirror.on("change", () => {
          this.updatePreview();
        });
      }
    });
  }

  updatePreview() {
    // Collect form data but send as POST regardless of form method
    const formData = new FormData(this.formTarget);

    // Remove Rails method override if present (converts PATCH/PUT to POST)
    formData.delete('_method');

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    fetch(this.previewUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken,
      },
      body: formData
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
        throw new Error('Preview generation failed');
      })
      .then((html) => {
        // Update iframe content
        const iframeDoc = this.iframeTarget.contentDocument || this.iframeTarget.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(html);
        iframeDoc.close();
      })
      .catch((error) => {
        console.error('Error updating preview:', error);
      });
  }

  // Trigger initial preview load
  loadPreview() {
    this.updatePreview();
  }
}
